import { render, staticRenderFns } from "./ScadaPointsDialog.vue?vue&type=template&id=a06c309c&scoped=true&"
import script from "./ScadaPointsDialog.vue?vue&type=script&lang=js&"
export * from "./ScadaPointsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ScadaPointsDialog.vue?vue&type=style&index=0&id=a06c309c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06c309c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VForm,VIcon,VRow,VTooltip})
